<template>
  <div>
    <div class="container-buttons">
      <router-link to="/cadastrar-movimentacao-carro">
        <button class="btn-custom btn-cobranca mb-3">
          <i class="fa fa-plus"></i> Cadastrar Movimentação
        </button>
      </router-link>
      <!--
      <a @click="showConfigModal">
        <i class="fa fa-cog btn-config mt-2 mr-3"></i>
      </a>
      -->
    </div>
    <card title="Movimentações de Carros" subTitle="Movimentações cadastradas">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Placa</th>
            <th>Motorista</th>
            <th>Km</th>
            <th>Data</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="carTransfer in carTransfers" :key="carTransfer.id">
              <td>{{ carTransfer.id }}</td>
              <td>{{ carTransfer.car.manufacturer }}</td>
              <td>{{ carTransfer.car.model }}</td>
              <td>{{ carTransfer.car.plate }}</td>
              <td>{{ carTransfer.driver.name }}</td>
              <td>{{ carTransfer.mileage }}</td>
              <td>{{ formatDate(new Date(carTransfer.createdAt)) }}</td>
              <td>
                <router-link :to="`/movimentacao-carros/${carTransfer.id}`">
                  <p-button type="info" outline icon title="Visualizar Movimentação">
                    <i class="fa fa-eye"></i>
                  </p-button>
                </router-link>
                <p-button type="info" outline icon title="Visualizar Contrato" @click.prevent.native="openContract(carTransfer.contractId)">
                  <i class="fa fa-file-text-o"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    carTransfers() {
      return this.$store.getters.carTransfers;
    },
    pagination() {
      return this.$store.getters.carTransfersPagination;
    },
  },
  methods: {
    ...mapActions(["fetchCarTransfers", "openContract"]),
    formatDate(date) {
      return formatDistance(date, new Date(), {
        locale: pt,
        addSuffix: true,
      });
    },
    async updatePagination({ currentPage }) {
      await this.fetchCarTransfers({ currentPage });
    },
  },
  async mounted() {
    try {
      await this.fetchCarTransfers();
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível carregar as transferências", "error");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  font-size: 20px;
}
.btn-modal {
  padding: 10px 60px;
}
.container-body {
  display: flex;

  p {
    font-size: 16px;
  }
}
.container-buttons {
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-stop-cobranca {
    background: #b80a0a;

    &:hover {
      background: #700202;
    }
  }

  &.btn-cron-cobranca {
    background: #ebb000;

    &:hover {
      background: #9c7500;
    }
  }

  &.btn-modal {
    padding: 10px 50px;
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}

.btn-outline-warning {
  border-color: #ffc107;
  color: #ffc107;

  &:hover {
    background: #ffc107 !important;
    background-color: #ffc107 !important;
    border-color: #ffc107;
  }
}

.modalPhones {
  ul {
    font-size: 18px;
    li {
      list-style: none;
    }
  }
}
</style>
<style>
@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>

